// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { eye16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-eye': IconEye;
    }
}

/**
 * The icon component for the 'eye' icon
 */
export class IconEye extends IconSvg {
    public constructor() {
        super(eye16X16);
    }
}

registerIconSvg('icon-eye', IconEye);
export const iconEyeTag = 'nimble-icon-eye';
